import type React from "react";

// Import the new components
import HomeHeroSection from "../components/HomeHeroSection";
import IntroductionSection from "../components/IntroductionSection";
import ProductCategoriesSection from "../components/ProductCategoriesSection";
import ContactSection from "../components/ContactSection";

const HomePage: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <HomeHeroSection 
        title="PES Lube"
        subtitle="Canadian supply of Sinopec oils, greases, and specialty fluids for industry, transportation, and equipment operations. Explore the product range or contact PES for availability, pricing, and technical documents."
        primaryButtonText="Browse Products"
        secondaryButtonText="Request a Quote"
      />

      {/* Introduction Section */}
      <IntroductionSection 
        title="SINOPEC Lubricant Company"
        subtitle="Sinopec is one of the world’s largest energy, refining, petrochemical, and lubricant companies, with a lubricant business serving major industrial and commercial markets around the world. Backed by large-scale production, technical development, and experience across major global industries, Sinopec Lubricants offers a full range of oils, greases, fluids, and specialty products for industrial manufacturing, mining and construction, automotive and agriculture, and aviation and marine applications."
      />

      {/* Product Categories */}
      <ProductCategoriesSection 
        title="Our Product Categories"
        subtitle=""
      />

      {/* Contact Section */}
      <ContactSection 
        title="Contact PES"
        subtitle=""
      />
    </div>
  );
};

export default HomePage;
